var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.restriction_data)?_c('span',[_c('strong',[_vm._v("Restricted Features : ")]),_c('span',[_vm._v(_vm._s(_vm.getRestrictionsByType('restricted_features')))]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Restricted Actions : ")]),_c('span',[_vm._v(_vm._s(_vm.getRestrictionsByType('restricted_actions')))]),_c('br')]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }